import React, { useState, useEffect } from "react";
import { API } from "../../pages/backend";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import {
  Avatar,
  Box,
  Card,
  Container,
  Grid,
  MenuItem,
  Typography,
} from "@mui/material";
import axios from "axios";
import {  useNavigate, } from "react-router-dom";
import { IconButton, Popover } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../reusables/layout/layout";
import InputField from "../forms/input/TextInput/InputField";
import FormButton from "../ui/button/FormButton";
import Spinner from "../ui/Spinner";
import { setTransactionDetails } from "../../store/reducers/transactionDetails";
import { examPrices } from "../../partials/examboardprices/examprices";
import Receipt from "../../paymentcomp/paymentreceipt";
import { showModal } from "../../store/reducers/modal";
import Tab from "../../Component/tab";
import BillCard from "../paymentcard/billcard";
import TransactionCard from "../transactioncard/transactioncard";
import PubSchReceipt from "../../paymentcomp/publicschreceipt";
import PaymentDispute from "../disputecard/dispute";
import { logOutUser } from "../../store/reducers/user";

const LatePaymentFormCASBece = ({ examName ='BECE', examType = 'BECE EXAMINATION', lateRegistrationType = "BECE Late Registration"}) => {


  const [tab, setTab] = useState(0);
  const tabs = ["User Details", "Payment Details", "Transaction Details", "Log Payment Dispute"];

  const dispatch = useDispatch();
  const [noOfCandidates, setNoOfCandidates] = useState(0);

  const price =
    examName === "BECE"
      ? examPrices.beceLateRegistrationFee 
      : examPrices.casLateRegistrationFee;

  const [priceInt, setPriceInt] = useState(price.replace(/\D/g, ""));
  const totalFee = priceInt * noOfCandidates;
  // console.log(totalFee);
  // console.log(priceInt);
  // console.log(noOfCandidates);

  const charge = 0.029 * totalFee;
  const totalAmount = parseInt(charge) + parseInt(totalFee);

  const user = useSelector((state) => state.user.data.details);

  // console.log(user);

  const token = useSelector((state) => state.user.data.token);
  const details = useSelector((state) => state.transactionDetails);

  // console.log(user);
  const [loading, setLoading] = useState(false);
  const [invoiceLoading, setInvoiceLoading] = useState(false);

  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const [drop, setDrop] = useState(false)



  const handleLogOut = () => {
    dispatch(logOutUser())
    navigate("/bece/payment/login");
  };

  const openAnchor = Boolean(anchorEl);
  const [errors, setErrors] = useState({});

  const [statuss, setStatuss] = useState(true);

  const closeAnchor = () => {
    setAnchorEl(null);
  };

  const goBack = () => {
    window.history.back();
  };

  const generateCode = async () => {
    const beceCodeUrl = `${API}auth/code/bece/`;
    const casCodeUrl = `${API}auth/code/cas/`;

    const examCodeUrl = examName === "B.E.C.E" ? beceCodeUrl : casCodeUrl;

    setLoading(true);
    try {
      const body = {
        assessmentCode: user?.categoryId,
        // schoolCode: user?.schoolCode,
        totalPaidForOrAllocated: noOfCandidates,
        paymentOwners: [
          {
            examIdOrSchoolId: user?.schoolId,
          },
        ],
        // rowId: user?.id,
      };
      const response = await axios.post(examCodeUrl, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response?.data?.status === "success") {
        console.log(response);
        console.log("got here");

        dispatch(
          showModal({
            content: (
              <PubSchReceipt
                {...response}
                tx_ref={"-"}
                name={user?.firstName + " " + user?.lastName}
                examCode={response?.data?.data?.details?.examNo}
                examType={examName}
                email={user?.email}
                noOfCandidates={noOfCandidates}
                price={"-"}
              />
            ),
          })
        );
        // navigate('/requisition/bece')
      }
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: `Unable to generate Exam Code. Something went wrong`,
        icon: "error",
        confirmButtonText: "Ok",
      });
    } finally {
      setLoading(false);
    }
  };

  const updatePublic = async () => {
    console.log(noOfCandidates);
    const remaining = user?.quota - noOfCandidates;
    console.log(remaining);

    const body = {
      quota: remaining,
    };

    const beceQuotaUpdateUrl = `${API}auth/bece/update/`;
    const casQuotaUpdateUrl = `${API}auth/cas/update/`;

    const updateQuotaUrl =
      examName === "B.E.C.E" ? beceQuotaUpdateUrl : casQuotaUpdateUrl;
    try {
      const response = await axios.patch(updateQuotaUrl, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response?.data?.status === "success") {
        console.log(response?.data?.data?.details?.quota);

        window.history.back();
        // dispatch(setUser(response?.data?.data?.details?.quota))
      }
    } catch (error) {
      console.log(error);
    }
    // updateGeneral(remaining, name, email, phone);
    // generateCodeUpdate();
  };

  const validateForm = () => {
    const newErrors = {};
    if (!noOfCandidates || noOfCandidates <= 0  ) {
      newErrors.noOfCandidates = "No of candidates is required";
    }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleClickPublic = async (e) => {
    e.preventDefault();
    const remaining = user?.quota - noOfCandidates;
    try {
      if (!validateForm()) {
        toast.error("No of candidates is required");
      } else if (user?.quota >= noOfCandidates) {
        await generateCode();
        updatePublic();
        // setRemaining(remaining);
      } else {
        toast.error("Number of candidates should not be more than Quota");
      } // updateGeneral(remaining, name, email, phone, lasra);
    } catch {
      toast.error("Number of candidates is more than the Quota");
    }
  };


  const saveGeneratedBill = async (body) => {
    try {
      const res = await axios.post(`${API}auth/bills/create`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(res);
    } catch (error) {}
  };

  const generateBillNo = async () => {
    const fullDesc =
      examName === "CAS/Placement"
        ? "Placement (Primary) All Primary Registration Fee[NGN]"
        : "Basic Education Certification[NGN]";

    const body = {
      payerId: "N-8592972",
      customerName: `${user.firstName} ${user.lastName}`,
      customerAddress: user.address,
      totalAmountInvoiced: totalFee,
      invoiceItems: [
        {
          productId: "68323",
        },
      ],
    };

    try {
      const res = await axios.post(`${API}cbs/create_invoice`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(res)
      if (res?.status === 200) {
        // console.log(res?.status);
        // console.log(res?.data);
        // console.log(res?.data?.data?.responseData);

        const billdata = {
          billNumber: res?.data?.data?.responseData,
          payerId: res?.data?.data?.payerId,
          amount: totalFee,
          fullName: `${user.firstName} ${user.lastName}`,
          totalPaidForOrAllocated: noOfCandidates,
          assessmentCode: examType === "BECE EXAMINATION" ? "04" : "03",
          paymentOwners: [
            {
              examsIdOrSchoolId: user?.schoolId,
            },
          ],
        };
        const bill = saveGeneratedBill(billdata);
        // console.log(bill);
        // transactionDetails.billNumber = res?.data?.data?.responseData;
        // console.log(transactionDetails);
        const userTransactionDetails = {
          payerName: `${user.firstName} ${user.lastName}`,
          productQuantity: noOfCandidates,
          price: totalFee,
          unitPrice: priceInt,
          examType,
          paymentExamType: examName,
          fullDesc,
          billNumber: res?.data?.data?.responseData,
          payerId: user?.payerId,
          address: user?.address,
          schoolName: user?.schoolName,
          priceWithCharge: totalAmount,
        };
        dispatch(setTransactionDetails(userTransactionDetails));
        // console.log(userTransactionDetails);
        // console.log(details);
        navigate("/invoice");
      }
      // console.log(res);
    } catch (error) {
      toast.error("Session expired. Please logout and try again.");
      console.log(error);
    }
  };

  const handleInvoiceClick = async (e) => {
    setInvoiceLoading(true);
    try {
      e.preventDefault();
      if (validateForm()) {
        await generateBillNo();
        // console.log(transactionDetails)
        // console.log(examName)
      } else {
        toast.error("No of candidates is required");
      }
    } catch (error) {
      console.log(error);
      toast.error("No of candidates is required");
    } finally {
      setInvoiceLoading(false);
    }
  };



  const LateReqForm = () => {
    return(
      <Container sx={{ mt: 2 }}>
      <div
        style={{
          marginTop: "3rem",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          // alignItems: "center",
          padding: window.innerWidth >= 400 ? "0px 70px" : "0px",
          // border: "solid 2px black",
        }}
      >
        <div>
          <div>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <InputField
                  name="school_type"
                  label="School Type"
                  type="schooltype"
                  placeholder="School Type"
                  value={user?.schoolType}
                  // onChange={(e) => {
                  //     setUsername(e.target.value);
                  // }}
                  style={{ height: "100%" }}
                />
              </Grid>
              <Grid item xs={6}>
                <InputField
                  name="Examination_code"
                  label="Examination Code"
                  type="ExaminationCode"
                  placeholder="Examination Code"
                  value={user?.schoolCode}
                  // onChange={(e) => {
                  //     setUsername(e.target.value);
                  // }}
                  style={{ height: "100%" }}
                />
              </Grid>
            </Grid>
          </div>
          <div>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <InputField
                  name="lga_id"
                  label="LGA ID"
                  type="localGovtId"
                  placeholder="Local Government ID"
                  value={user?.lgaId}
                  // onChange={(e) => {
                  //     setUsername(e.target.value);
                  // }}
                  style={{ height: "100%" }}
                />
              </Grid>
              <Grid item xs={6}>
                <InputField
                  name="name_of_school"
                  label="Name of School"
                  type="nameofschool"
                  placeholder="Name of School"
                  value={user?.schoolName}
                  // onChange={(e) => {
                  //     setUsername(e.target.value);
                  // }}
                  style={{ height: "100%" }}
                />
              </Grid>
            </Grid>
          </div>

          <Typography variant="body1" sx={{ mt: 5, fontWeight: "bold" }}>
            Contact Details:
          </Typography>
          <div>
            <Grid container spacing={2}>
              <Grid item xs={6} md={6}>
                <InputField
                  name="name"
                  label="Name"
                  type="name"
                  placeholder="Name"
                  value={user?.firstName + " " + user?.lastName}
                  // readOnly={statuss? true : false}
                  // onChange={(e) => {
                  //     setUsername(e.target.value);
                  // }}
                  style={{ height: "100%" , textTransform: 'capitalize'}}
                />
                {errors.name && (
                  <div style={{ color: "red", fontSize: "15px" }}>
                    {errors.name}
                  </div>
                )}
              </Grid>
              <Grid item xs={6}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    position: "relative",
                  }}
                >
                  <Typography
                    href=""
                    color="secondary"
                    style={{
                      color: "#e53e3e",
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "flex-end",
                      textTransform: "inherit",
                      position: "absolute",
                      top: "0.8rem",
                      left: "7em",
                    }}
                    variant="p"
                  >
                    Forget Payer ID?
                  </Typography>
                  {/* <Typography
              href=""
              color="secondary"
              style={{
                fontSize: "12px",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                textTransform: "inherit",
              }}
              variant="p"
            >
              Don't have a payer ID? Request.
            </Typography> */}
                </div>
                <InputField
                  name="payerId"
                  label="Payer ID"
                  type="payer_ID"
                  placeholder="Payer ID or No"
                  value={user?.payerId}
                  // onChange={(e) => {
                  //     setUsername(e.target.value);
                  // }}
                  style={{ height: "100%" }}
                />
              </Grid>
            </Grid>

            <div>
              {user?.categoryId === "01" ? (
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <InputField
                      type="number"
                      min="0"
                      name="no_of_candidates"
                      label="Number of Candidates"
                      // type='no_of_candidates'
                      placeholder="Number of candidates"
                      value={noOfCandidates || ""}
                      onChange={(e) => setNoOfCandidates(e.target.value)}
                      style={{ height: "100%" }}
                    />
                    {/* {errors.phone && (
                            <div style={{ color: "red", fontSize: '15px' }}>{errors.phone}</div>
                        )} */}
                  </Grid>
                  <Grid item xs={6}>
                    <InputField
                      name="quota"
                      label="Quota"
                      placeholder="Quota"
                      type="quota"
                      value={user?.quota || 0}
                      style={{ height: "100%" }}
                    />
                  </Grid>
                </Grid>
              ) : (
                <>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <InputField
                        name="email"
                        label="Email"
                        type="email"
                        placeholder="Email"
                        value={user?.email}
                        // onChange={(e) => {
                        //     setUsername(e.target.value);
                        // }}
                        style={{ height: "100%" }}
                      />
                      {errors.email && (
                        <div style={{ color: "red", fontSize: "15px" }}>
                          {errors.email}
                        </div>
                      )}
                    </Grid>

                    <Grid item xs={6}>
                      <InputField
                        name="fee_per_candidate"
                        label="Fee per Candidate"
                        type="fee_per_candidate"
                        placeholder="Fee per candidate"
                        value={price}
                        // onChange={(e) => {
                        //     setUsername(e.target.value);
                        // }}
                        style={{ height: "100%" }}
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <InputField
                        min="0"
                        type="number"
                        name="no_of_candidates"
                        label="Number of Candidates"
                        // type='no_of_candidates'
                        placeholder="Number of Candidates"
                        value={noOfCandidates || ""}
                        onChange={(e) => {
                          setNoOfCandidates(e.target.value.trim());
                        }}
                        style={{ height: "100%" }}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <InputField
                        name="totalFee"
                        label="Total Fee"
                        type="totalFee"
                        placeholder="Total Fee"
                        value={totalFee ? "₦" + totalFee : "₦" + 0}
                        // onChange={(e) => {
                        //     setUsername(e.target.value);
                        // }}
                        style={{ height: "100%" }}
                      />
                    </Grid>
                  </Grid>
                </>
              )}
            </div>
          </div>

          <div
            style={{
              marginTop: "3rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {user?.categoryId === "01" ? (
              <FormButton
                // type="submit"
                label={loading ? <Spinner width="5%" /> : " Generate Code"}
                width="medium"
                onClick={handleClickPublic}
              />
            ) : (
              <FormButton
                type="submit"
                label={
                  invoiceLoading ? <Spinner width="5%" /> : "Generate Invoice"
                }
                width="medium"
                onClick={handleInvoiceClick}
              />
            )}
            <div>
              {/* <Link
        component="button"
        // to="/"
        sx={{ color: "#000", textDecoration: "none" }}
      > */}
              <FormButton label={"Go Back"} width="medium" onClick={goBack} />

              {/* </Link> */}
            </div>
          </div>
        </div>
      </div>
    </Container>
    )
  }


  return (
    <div>
      <Layout>
        <Card className="dues-card" elevation={5}>
          <Box
            component="form"
            noValidate
            autoComplete="off"
            className="dues-form-left"
          >
            <div style={{ padding: "0px 5px" }}>
              <marquee bgcolor="white" direction="left" loop="">
                <Typography>
                  <span
                    style={{
                      color: "red",
                      fontSize: "14px",
                      fontWeight: "600",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    *This is a Late Payment Form. You are paying outside the initial exam window.
                  </span>
                </Typography>
              </marquee>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  paddingTop: "5px",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    paddingTop: "10px",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    style={{
                      // marginLeft: "10px",
                      // paddingTop: "8px",
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                    }}
                  >
                    Welcome back
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      textTransform: 'capitalize'
                    }}
                  >
                    {user?.firstName + " " + user?.lastName}
                  </Typography>
                </div>
                <div>
                  <Avatar
                    className=" lg:!flex xs:!hidden items-center"
                    size="large"
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    aria-label="account-circle"
                    style={{
                      backgroundColor: "#34A56F",
                      // lineHeight: '50px',
                      fontFamily: "Palanquin",
                      fontStyle: "normal",
                      fontWeight: 700,
                      fontSize: "20px",
                      textAlign: "center",
                      cursor: "pointer",
                      width: "35px",
                      height: "35px",
                    }}
                  >
                    {user?.firstName?.charAt(0)?.toUpperCase() +
                      user?.lastName?.charAt(0)?.toUpperCase()}
                  </Avatar>
                  <Popover
                    open={openAnchor}
                    anchorEl={anchorEl}
                    onClose={closeAnchor}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    <MenuItem onClick={() => dispatch(logOutUser())}>Logout</MenuItem>
                  </Popover>
                </div>
              </div>
            </div>
            <div style={{
                 
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center'
                }} >
              <Typography
                variant="h4"
                align="center"
                style={{
                  padding: "0px 5px",
                  fontWeight: "bold",
                  marginTop: "10px",
                }}
              >{`${examName}`}</Typography>
             
              <Typography
                variant="h5"
                align="center"
                style={{
                  padding: "0px 5px",
                  fontWeight: "bold",
                  marginTop: "5px",
                }}
              >
                {"Requisition Form"}
              </Typography>
              <Typography
                
                align="center"
                style={{
                  color: 'white',
                  fontSize: '22px',
                  padding: "0px 5px",
                  fontWeight: "bold",
                  marginTop: "5px",
                  background: '#FD0014',
                  width: '180px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '3px'
                }}
              >
                {"Late Payment"}
              </Typography>
             
            </div>
            <tabs>
              {user?.categoryId === "01" ? (
                <Tab
                  text={"User Details"}
                  active={0 === tab}
                  onClick={() => setTab(0)}
                />
              ) : (
                tabs.map((x, i) => (
                  <Tab
                    key={i}
                    text={x}
                    active={i === tab}
                    onClick={() => setTab(i)}
                  />
                ))
              )}
            </tabs>
            {/* {tab === 0 && ReqForm()} */}
            {tab === 0 && LateReqForm()}
            {tab === 1 && <BillCard />}
            {tab === 2 && <TransactionCard />}
            {tab === 3 && <PaymentDispute type={examType} />}
            
            
          </Box>
          <Box compnent="div" className="bece-form-right">
            <Typography
              variant="h4"
              align="center"
              sx={{ color: "#ffffff",  fontWeight: "bold" }}
            >
              Lagos State Exam Board
            </Typography>

            <img src={"/assets/images/laags.png"} alt="logo" />
            <Typography
              variant="h4"
              align="center"
              sx={{ color: "white", fontWeight: "bold", mb: 3 }}
            >
              {lateRegistrationType}
            </Typography>
            <Typography
              variant="body2"
              align="center"
              sx={{ color: "white", fontSize: "20px" }}
            >
              Fill the form to request for the Official Central Billing System
              Invoice ID
            </Typography>
          </Box>
        </Card>
        {/* <ProceedModal piepie={pinNum} open={open} handleClose={handleClose} /> */}
      </Layout>
    </div>
  );
};

export default LatePaymentFormCASBece;
